__turbopack_context__.v({
  "agreementHours": "client-dossier-tabs-visual-module__GUVh8a__agreementHours",
  "agreementLabel": "client-dossier-tabs-visual-module__GUVh8a__agreementLabel",
  "agreementPrice": "client-dossier-tabs-visual-module__GUVh8a__agreementPrice",
  "agreementRow": "client-dossier-tabs-visual-module__GUVh8a__agreementRow",
  "agreementRowDated": "client-dossier-tabs-visual-module__GUVh8a__agreementRowDated",
  "agreementWhen": "client-dossier-tabs-visual-module__GUVh8a__agreementWhen",
  "avatar": "client-dossier-tabs-visual-module__GUVh8a__avatar",
  "budgetFill": "client-dossier-tabs-visual-module__GUVh8a__budgetFill",
  "budgetFoot": "client-dossier-tabs-visual-module__GUVh8a__budgetFoot",
  "budgetTrack": "client-dossier-tabs-visual-module__GUVh8a__budgetTrack",
  "card": "client-dossier-tabs-visual-module__GUVh8a__card",
  "cardBody": "client-dossier-tabs-visual-module__GUVh8a__cardBody",
  "cardHead": "client-dossier-tabs-visual-module__GUVh8a__cardHead",
  "cardTitle": "client-dossier-tabs-visual-module__GUVh8a__cardTitle",
  "check": "client-dossier-tabs-visual-module__GUVh8a__check",
  "checkDone": "client-dossier-tabs-visual-module__GUVh8a__checkDone",
  "chip": "client-dossier-tabs-visual-module__GUVh8a__chip",
  "figure": "client-dossier-tabs-visual-module__GUVh8a__figure",
  "figureAccent": "client-dossier-tabs-visual-module__GUVh8a__figureAccent",
  "figureLabel": "client-dossier-tabs-visual-module__GUVh8a__figureLabel",
  "figureSignal": "client-dossier-tabs-visual-module__GUVh8a__figureSignal",
  "figureValue": "client-dossier-tabs-visual-module__GUVh8a__figureValue",
  "figures": "client-dossier-tabs-visual-module__GUVh8a__figures",
  "footer": "client-dossier-tabs-visual-module__GUVh8a__footer",
  "footerAmount": "client-dossier-tabs-visual-module__GUVh8a__footerAmount",
  "line": "client-dossier-tabs-visual-module__GUVh8a__line",
  "lineLabel": "client-dossier-tabs-visual-module__GUVh8a__lineLabel",
  "lineValue": "client-dossier-tabs-visual-module__GUVh8a__lineValue",
  "lineValueAccent": "client-dossier-tabs-visual-module__GUVh8a__lineValueAccent",
  "memberFill": "client-dossier-tabs-visual-module__GUVh8a__memberFill",
  "memberHours": "client-dossier-tabs-visual-module__GUVh8a__memberHours",
  "memberName": "client-dossier-tabs-visual-module__GUVh8a__memberName",
  "memberRow": "client-dossier-tabs-visual-module__GUVh8a__memberRow",
  "memberTrack": "client-dossier-tabs-visual-module__GUVh8a__memberTrack",
  "panel": "client-dossier-tabs-visual-module__GUVh8a__panel",
  "panelShown": "client-dossier-tabs-visual-module__GUVh8a__panelShown",
  "panels": "client-dossier-tabs-visual-module__GUVh8a__panels",
  "person": "client-dossier-tabs-visual-module__GUVh8a__person",
  "personDot": "client-dossier-tabs-visual-module__GUVh8a__personDot",
  "personName": "client-dossier-tabs-visual-module__GUVh8a__personName",
  "personText": "client-dossier-tabs-visual-module__GUVh8a__personText",
  "root": "client-dossier-tabs-visual-module__GUVh8a__root",
  "stack": "client-dossier-tabs-visual-module__GUVh8a__stack",
  "stackUneven": "client-dossier-tabs-visual-module__GUVh8a__stackUneven",
  "sub": "client-dossier-tabs-visual-module__GUVh8a__sub",
  "tab": "client-dossier-tabs-visual-module__GUVh8a__tab",
  "tabActive": "client-dossier-tabs-visual-module__GUVh8a__tabActive",
  "tabCount": "client-dossier-tabs-visual-module__GUVh8a__tabCount",
  "tabRule": "client-dossier-tabs-visual-module__GUVh8a__tabRule",
  "tabs": "client-dossier-tabs-visual-module__GUVh8a__tabs",
  "taskCount": "client-dossier-tabs-visual-module__GUVh8a__taskCount",
  "taskFill": "client-dossier-tabs-visual-module__GUVh8a__taskFill",
  "taskFillDone": "client-dossier-tabs-visual-module__GUVh8a__taskFillDone",
  "taskLabel": "client-dossier-tabs-visual-module__GUVh8a__taskLabel",
  "taskLabelDone": "client-dossier-tabs-visual-module__GUVh8a__taskLabelDone",
  "taskProgress": "client-dossier-tabs-visual-module__GUVh8a__taskProgress",
  "taskRow": "client-dossier-tabs-visual-module__GUVh8a__taskRow",
  "taskTrack": "client-dossier-tabs-visual-module__GUVh8a__taskTrack",
  "twoUp": "client-dossier-tabs-visual-module__GUVh8a__twoUp",
  "wideOnly": "client-dossier-tabs-visual-module__GUVh8a__wideOnly",
  "wideOnlyLine": "client-dossier-tabs-visual-module__GUVh8a__wideOnlyLine",
});
